import KnownMeasureTranslationPage from './KnownMeasureTranslationsPage';

export default KnownMeasureTranslationPage;